import { Component } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { HistoricalAlertWorkSessionMatPaginatorIntl } from "../../dashboard-area/shared/historical-alert-work-session-mat-paginator-intl.service";
import { ListRangeSelectionModeType } from "../../model";
import { ListPaginator } from "./list-paginator.component";

@Component({
    selector: 'historical-list-paginator',
    template: require('./list-paginator.component.html'),
    styles: [require('./list-paginator.component.css')],
    providers: [{ provide: MatPaginatorIntl, useClass: HistoricalAlertWorkSessionMatPaginatorIntl }]
})
export class HistoricalListPaginator extends ListPaginator {

    protected updatePaginatorClass(): void {
        this.matPaginatorClass = "mat-paginator-hidden-last ";
        if (this.authenticationService.getTenant().listRangeSelectionMode == ListRangeSelectionModeType.PAGES) {
            this.matPaginatorClass += "mat-paginator-pages-mode";
        } else {
            this.matPaginatorClass += "mat-paginator-hidden-range-label";
        }
    }
}